module.exports = __webpack_public_path__ + "static/media/okladka-poradnik.23b4a699.webp";